class OtherVersions extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('[data-other-version-item]')];
    this.pagination = this.querySelector('[data-other-versions-pagination]');
    this.pageSize = 10;
    this.page = 1;
    this.render();
    this.pagination?.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-page]');
      if (!button || button.disabled) return;
      this.page = Number(button.dataset.page);
      this.render(true);
    });
  }

  render(focus = false) {
    const pageCount = Math.ceil(this.items.length / this.pageSize);
    const first = (this.page - 1) * this.pageSize;
    this.items.forEach((item, index) => { item.hidden = index < first || index >= first + this.pageSize; });
    if (!this.pagination) return;
    this.pagination.hidden = pageCount <= 1;
    if (pageCount <= 1) return;
    const button = (label, page, disabled = false, current = false) =>
      `<button type="button" data-page="${page}"${disabled ? ' disabled' : ''}${current ? ' aria-current="page"' : ''}>${label}</button>`;
    this.pagination.innerHTML = [
      button('Previous', this.page - 1, this.page === 1),
      ...Array.from({ length: pageCount }, (_, index) => button(String(index + 1), index + 1, false, index + 1 === this.page)),
      button('Next', this.page + 1, this.page === pageCount),
    ].join('');
    if (focus) this.pagination.querySelector('[aria-current="page"]')?.focus();
  }
}

if (!customElements.get('other-versions')) customElements.define('other-versions', OtherVersions);
